import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { gamesApi } from '../services/api';
import './Searching.css';

function Searching({ username, userId, userLocation, locationError, onGameFound, onLogout }) {
  const navigate = useNavigate();
  const [dots, setDots] = useState('');
  const [searchStatus, setSearchStatus] = useState('searching');
  const [error, setError] = useState(null);

  useEffect(() => {
    // Animate dots
    const dotsInterval = setInterval(() => {
      setDots((prev) => (prev.length >= 3 ? '' : prev + '.'));
    }, 500);

    return () => {
      clearInterval(dotsInterval);
    };
  }, []);

  useEffect(() => {
    if (locationError) {
      setError(locationError);
      setSearchStatus('error');
      return;
    }

    if (!userLocation) {
      return; // Still waiting for location
    }

    const searchForGames = async () => {
      try {
        setSearchStatus('searching');
        const response = await gamesApi.getAvailableGames(
          userLocation.lat,
          userLocation.lon,
          userId
        );

        if (response.success && response.data.games.length > 0) {
          // Found games - select the first one
          const game = response.data.games[0];
          onGameFound(game);
          setSearchStatus('found');
          setTimeout(() => {
            navigate('/game');
          }, 1500);
        } else {
          setSearchStatus('not_found');
        }
      } catch (err) {
        console.error('Error searching for games:', err);
        setError(err.message || 'Failed to search for games');
        setSearchStatus('error');
      }
    };

    searchForGames();
  }, [userLocation, locationError, userId, onGameFound, navigate]);

  const handleRetry = () => {
    setError(null);
    setSearchStatus('searching');
    window.location.reload();
  };

  return (
    <div className="searching-container">
      <div className="status-bar">
        <span className="time">9:41</span>
        <div className="status-icons">
          <span className="signal"></span>
          <span className="wifi"></span>
          <span className="battery"></span>
        </div>
      </div>

      <div className="searching-content">
        <div className="user-welcome">
          <h2>Welcome, {username}!</h2>
          <button className="logout-button" onClick={onLogout}>Logout</button>
        </div>

        {searchStatus === 'searching' && (
          <>
            <div className="searching-animation">
              <div className="radar-container">
                <div className="radar-wave"></div>
                <div className="radar-wave"></div>
                <div className="radar-wave"></div>
                <div className="radar-center">
                  <div className="poker-icon">♠</div>
                </div>
              </div>
            </div>

            <div className="searching-text">
              <h3>Searching for games{dots}</h3>
              <p>Looking for poker games within 1000 ft</p>
            </div>

            <div className="location-indicator">
              <span className="location-icon">📍</span>
              <span>
                {userLocation
                  ? 'Using your location'
                  : 'Getting your location...'}
              </span>
            </div>
          </>
        )}

        {searchStatus === 'found' && (
          <div className="found-section">
            <div className="found-icon">✓</div>
            <h3>Game Found!</h3>
            <p>Joining game...</p>
          </div>
        )}

        {searchStatus === 'not_found' && (
          <div className="not-found-section">
            <div className="not-found-icon">🎴</div>
            <h3>No Games Found</h3>
            <p>There are no poker games starting within 1000 ft right now.</p>
            <button className="retry-button" onClick={handleRetry}>
              Try Again
            </button>
          </div>
        )}

        {searchStatus === 'error' && (
          <div className="error-section">
            <div className="error-icon">⚠️</div>
            <h3>Error</h3>
            <p>{error}</p>
            <button className="retry-button" onClick={handleRetry}>
              Try Again
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default Searching;
